const createUser = () => `companies`;

export default {
  createUser
};
